import AudioFactory from 'scripts/application/lib/audio_factory';
import { DEFAULT_CHANNEL_SOUNDS, NotificationSoundType } from 'actions/notification/lib/notification_constants';
import { endpointChannelForInteractionType } from 'actions/notification/lib/channel_for_interaction_type';

export const LastPlayed = {};

export default function playNotificationSound(type) {
  let soundSrc = getSoundUrlByType(type);
  if (soundSrc) {
    let audio = AudioFactory.create();
    audio.src = soundSrc;
    audio.play();
  }
}

export function playChannelNotificationSound(preferences, interactionType) {
  const channel = endpointChannelForInteractionType(interactionType);
  if (!channel) {
    return;
  }

  const customize = !!(preferences && preferences.customizeChannelNotificationSounds);
  if (!customize) {
    // Agents who don't opt in keep the pre-PR behavior: every inbound message
    // plays the original sound.
    playNotificationSound(NotificationSoundType.INBOUND_MESSAGE);
    return;
  }

  const channelSounds = (preferences && preferences.channelNotificationSounds) || {};
  const soundType = channel in channelSounds ? channelSounds[channel] : DEFAULT_CHANNEL_SOUNDS[channel];
  playNotificationSound(soundType);
}

function getSoundUrlByType(type) {
  switch (type) {
    case NotificationSoundType.AGENT_NOTIFICATION:
      return '/audio/notification_sound.mp3';
    case NotificationSoundType.DECLINED_SESSION_REASSIGNMENT:
    case NotificationSoundType.INBOUND_MESSAGE:
    case NotificationSoundType.PAYMENT_STATUS_EVENT:
    case NotificationSoundType.CLICK:
      return '/audio/cuteclicks.mp3';
    case NotificationSoundType.BELL_CHIME:
      return '/audio/clear-bell-chime-487898.mp3';
    case NotificationSoundType.MELODY:
      return '/audio/domisodo.mp3';
    case NotificationSoundType.HAPPY:
      return '/audio/new-notification-happy.mp3';
    case NotificationSoundType.SOFT_BELL:
      return '/audio/soft-bell-ding-485895.mp3';
    case NotificationSoundType.POP:
      return '/audio/pop.mp3';
    case NotificationSoundType.CLICKIES:
      return '/audio/clickies.mp3';
    case NotificationSoundType.SOFT_DING:
      return '/audio/softding.mp3';
    default:
      return undefined;
  }
}
